<template>
  <div class="modal_container">
    <div class="modal">
      <div class="modal-content">
        <div class="caption">
          <div class="title">{{textContent.titleAdd}}</div>
          <div @click="modalClose" class="close"></div>
        </div>
        <div class="modal-scroll">
          <form v-on:submit.prevent="addItem">
            <form-input name="name"></form-input>
            <form-input name="city"></form-input>
            <form-file use-case="cover" name="img"></form-file>
            <form-text-area name="message"></form-text-area>
          </form>
          <div class="buttons">
            <div class="next">
              <button @click="modalClose" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" @click="addItem">{{textContent.submitButton}} &#8594;</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import {createNamespacedHelpers} from 'vuex'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import Tabs from '@/components/create-form/Tabs'

  const {mapMutations, mapGetters, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    computed: {
      ...mapState([
        'textContent'
      ]),
      ...mapGetters([
        'isLastTab'
      ])
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev'
      ]),
      ...mapMutations([
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions'
      ]),
    },
    created() {
      this.setCurrentTabId(0)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        name: {
          value: '',
          parameterName: 'name',
          name: 'Имя автора',
          errorId: null,
          errors: {empty: 'Введите имя автора'},
          tabId: 0
        },
        city: {
          value: '',
          parameterName: 'city',
          name: 'Город',
          errorId: null,
          errors: {empty: 'Введите город автора'},
          tabId: 0
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        type_id: {
          value: 2,
          parameterName: 'type_id',
          isNullable: true,
          tabId: 0
        },
        is_viewed: {
          value: 1,
          parameterName: 'is_viewed',
          isNullable: true,
          tabId: 0
        },
        message: {
          value: '',
          parameterName: 'message',
          name: 'Отзыв',
          errorId: null,
          errors: {empty: 'Введите отзыв'},
          tabId: 0
        },
      })
    },
    components: {
      FormInput,
      FormTextArea,
      FormFile,
      Tabs
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/reviews/common/CreateModal.vue